function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5,64.534l46.415-28.941c-0.505-0.08-1.017-0.132-1.542-0.132H24.627c-0.525,0-1.038,0.054-1.541,0.132L69.5,64.534z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M72.421,75.723c-0.062,0.04-0.13,0.066-0.194,0.104c-0.067,0.037-0.139,0.073-0.206,0.107  c-0.365,0.188-0.741,0.339-1.125,0.439c-0.04,0.011-0.078,0.017-0.116,0.025c-0.423,0.099-0.848,0.16-1.274,0.16  c-0.001,0-0.003,0-0.004,0s-0.003,0-0.005,0c-0.426,0-0.852-0.06-1.273-0.16c-0.039-0.009-0.079-0.015-0.118-0.025  c-0.384-0.101-0.757-0.252-1.124-0.439c-0.069-0.034-0.139-0.07-0.207-0.107c-0.065-0.037-0.132-0.063-0.196-0.104L15.005,43.564  c-0.093,0.544-0.153,1.099-0.153,1.671v51.609c0,5.398,4.375,9.774,9.774,9.774h89.746c5.398,0,9.774-4.376,9.774-9.774V45.235  c0-0.572-0.059-1.127-0.154-1.671L72.421,75.723z"
});

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 139 139",
    id: "Mail",
    viewBox: "0 0 139 139",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.320e5784.svg";
export { ForwardRef as ReactComponent };